import Keycloak from "keycloak-js";

/**
 * Atlas UI talks to the same Keycloak realm as bridge-fusion. SSO works
 * only when both apps point at the *same* Keycloak host + realm — a mismatch
 * means each gets its own cookie and silent SSO can never succeed.
 *
 * Override at runtime via .env (VITE_KEYCLOAK_URL / _REALM / _CLIENT_ID).
 */
const keycloakConfig = {
  url: import.meta.env.VITE_KEYCLOAK_URL || "https://auth.dev.bridgeai.co.uk/",
  realm: import.meta.env.VITE_KEYCLOAK_REALM || "bridgeai-platform",
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || "bridge-atlas-ui",
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
export { keycloakConfig };